export const DATA_HOOKS = {
  fullScreenModalLayoutRoot: 'fullScreenModalLayout-root',
  fullScreenModalLayoutHeader: 'fullScreenModalLayout-header',
  fullScreenModalLayoutContent: 'fullScreenModalLayout-content',
  fullScreenModalLayoutFooter: 'fullScreenModalLayout-footer',
};
